const allowedDomains = ["cmcalc.test", "cmcalc.com"];

const isDomainAllowed = allowedDomains.some(domain => window.location.href.includes(domain));

if (!isDomainAllowed) {
    document.body.innerHTML = '';
}
